import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function NotificationMessage(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      sx,
      viewBox,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "NotificationMessage",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M35.25 14.25v15c-.0006.4036-.0826.8029-.2411 1.174-.1585.3712-.3903.7065-.6814.986-.558.5378-1.3025.8389-2.0775.84H9.75c-.775-.0011-1.5195-.3022-2.0775-.84-.29115-.2795-.52291-.6148-.68142-.986-.15851-.3711-.24051-.7704-.24108-1.174v-15c0-.7956.31607-1.5587.87868-2.1213.56261-.5626 1.32567-.8787 2.12132-.8787h22.5c.7956 0 1.5587.3161 2.1213.8787.5626.5626.8787 1.3257.8787 2.1213Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M34.26 12 21 23.25 7.74 12c.55465-.4892 1.27046-.7563 2.01-.75h22.5c.7395-.0063 1.4553.2608 2.01.75Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M37.5 25.5c0-.5967-.2371-1.169-.659-1.591-.422-.4219-.9943-.659-1.591-.659s-1.169.2371-1.591.659c-.4219.422-.659.9943-.659 1.591m2.25 11.25c.5967 0 1.169-.2371 1.591-.659.4219-.422.659-.9943.659-1.591H33c0 .5967.2371 1.169.659 1.591.422.4219.9943.659 1.591.659Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M41.25 34.5h-12c.2792-.4849.5297-.9857.75-1.5.4478-1.6352.8108-3.2924 1.0875-4.965.1139-.912.5588-1.7503 1.2501-2.3559.6913-.6056 1.5809-.9362 2.4999-.9291h.885c.919-.0071 1.8086.3235 2.4999.9291.6913.6056 1.1362 1.4439 1.2501 2.3559.257 1.6715.5999 3.3287 1.0275 4.965.2203.5143.4708 1.0151.75 1.5Z",
            fill: theme.vars.palette.secondary.dark
          }
        )
      ]
    }
  );
}
NotificationMessage.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "NotificationMessage"
};
validateTidalLicense();
export {
  NotificationMessage
};
//# sourceMappingURL=NotificationMessage.js.map
